import { all, call, put, takeLatest } from "redux-saga/effects";
import shopApi from "../../../api/shopApi";
import {
  GET_SHOPS_REQUEST,
  getShopsFailure,
  getShopsSuccess,
} from "./shopActions";

function* watchGetShops(action) {
  try {
    const result = yield call(async () => {
      return await shopApi.getShops(action.payload);
    });
    yield put(getShopsSuccess(result));
  } catch (error) {
    yield put(getShopsFailure(error));
  }
}

function* shopSaga() {
  yield all([takeLatest(GET_SHOPS_REQUEST, watchGetShops)]);
}

export default shopSaga;
